import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import Events from 'events/events';
import SignupModal from './SignupModal';
import { dispatchEvent } from 'helpers/analytics/AnalyticsEventDispatcher';
import { isMobile } from 'helpers/device';

let searchOpen = false;

const mobileHeaderBanner = document.querySelector('.sticky--with-header-banner .header-banner-wrapper');
const HEADER_BANNER_HIDE_OFFSET_PX = 90;
const signupLightboxLinkId = '#signup-lightbox';
const styles = {
  content: 'email-signup-content banner-content',
}

function triggerAnalytics(action) {
  dispatchEvent('dataStateChange', { action });
}

class HeaderBanner extends PureComponent {
  constructor() {
    super();
    this.state = {
      showModal: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.init();
  }

  init() {
    Events.searchWillOpen.register(this.onSearchWillOpen.bind(this));
    Events.searchWillClose.register(this.onSearchWillClose.bind(this));
  }

  componentDidMount() {
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    const links = document.querySelectorAll(signupLightboxLinkId);
    links.forEach(link => link.onclick = this.openModal);
    window.addEventListener('scroll', this.handleScroll);
  }

  onSearchWillOpen() {
    if (mobileHeaderBanner && isMobile()) {
      const banners = document.querySelectorAll('.header-banner-wrapper');
      banners.forEach(banner => banner.classList.add('hidden'));

      // set flag
      searchOpen = true;
    }
  }

  onSearchWillClose() {
    if (!mobileHeaderBanner || window.pageYOffset > HEADER_BANNER_HIDE_OFFSET_PX) {
      return;
    }

    const banners = document.querySelectorAll('.header-banner-wrapper');
    banners.forEach(banner => banner.classList.remove('hidden'));

    // reset flag
    searchOpen = false;
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (!mobileHeaderBanner || searchOpen) return;

    if (window.pageYOffset > HEADER_BANNER_HIDE_OFFSET_PX) {
      mobileHeaderBanner.classList.add('hidden');
    } else {
      mobileHeaderBanner.classList.remove('hidden');
    }
  }

  openModal(e) {
    e.preventDefault();
    triggerAnalytics('rtb.bannerHeader');
    Events.modalWillOpen.trigger(document);
    this.setState({ showModal: true });
  }

  closeModal() {
    Events.modalWillClose.trigger(document);
    this.setState({ showModal: false });
  }

  render() {
    return (
      <span className={styles.content}>
        <span dangerouslySetInnerHTML={{__html: `${this.props.children}`}}/>
        {this.state.showModal && (
          <SignupModal onClose={this.closeModal} />
        )}
      </span>
    );
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const parentNode = document.querySelector('#header-banner');
  if (!parentNode) return;

  ReactDOM.render(
    <HeaderBanner>
      {parentNode.innerHTML}
    </HeaderBanner>,
    parentNode
  );
});
